﻿export default () => ({
    el: undefined,
    init() {
        this.el = this.$el;

        const id = this.el.getAttribute("data-grid-id");
        if (id) {
            // sessionStorage.removeItem(`${id}-filter`);
            // sessionStorage.removeItem(`${id}-sort`);
            // sessionStorage.removeItem(`${id}-page`);
            // sessionStorage.removeItem(`${id}-context`);
        }

        this.el.addEventListener('htmx:config-request', (evt) => {
            console.log(evt);

            const id = this.el.getAttribute("data-grid-id");
            const filter = sessionStorage.getItem(`${id}-filter`) ?? "";
            const sort = sessionStorage.getItem(`${id}-sort`) ?? "";
            let page = sessionStorage.getItem(`${id}-page`) ?? "1";
            if (page.trim() === "") {
                page = "1";
            }

            evt.detail.parameters['filter'] = filter;
            evt.detail.parameters['sort'] = sort;
            //evt.detail.parameters['page'] = page;
            evt.detail.path = `${evt.detail.path}/${page}`;

            //let context = sessionStorage.getItem(`realPeriodGrid-context`) ?? "";
            let context = sessionStorage.getItem(`${id}-context`) ?? "";

            if (this.el.name === "expand") {
                if (this.el.checked) {
                    context += "expanded"
                } else {
                    context = context.replace("expanded", "")
                }
            } else if (this.el.name === "allPeriods") {
                if (this.el.checked) {
                    context += "allPeriods"
                } else {
                    context = context.replace("allPeriods", "")
                }
            }

            sessionStorage.setItem(`${id}-context`, context);
            evt.detail.parameters['context'] = context;
        });
    }
});